export default __webpack_public_path__ + "static/media/full_screen_illustration.56d90ec1.png";